import type { LessonEditStore } from './interfaces'

export const createLessonEditState = (): LessonEditStore => ({
  loading: false,
  lesson: null,
  slots: null,
  date: '',
  startTime: '',
  duration: null,
  status: null,
  reasonCategory: null,
  reason: null,
  tutorId: null,
  filters: null,
  tutorModalOpen: false,
  actionModal: null,
  deleteConfirmOpen: false,
  reassignReason: null,
  reassignComment: '',
  saving: false,
})
